<template>
  <transition
    @before-enter="beforeEnter"
    @enter="enter"
    @after-enter="afterEnter"
    @before-leave="beforeLeave"
    @leave="leave"
  >
    <div
      v-show="isVisible"
      class="slide-container"
      ref="contentRef"
      :class="{ isClosed: !isVisible }"
    >
      <slot></slot>
    </div>
  </transition>
</template>

<script lang="ts" setup>
import { defineProps, ref, nextTick, watch, withDefaults } from "vue";

const props = withDefaults(defineProps<{ isVisible: boolean; inverted?: boolean }>(), {
  inverted: false,
});

const contentRef = ref<HTMLElement | null>(null);

watch(
  () => props.isVisible,
  async newVal => {
    if (newVal && contentRef.value) {
      await nextTick();

      // set height based on expand
      contentRef.value.style.height = `${contentRef.value.scrollHeight}px`;
    }
  },
);

const beforeEnter = (el: Element) => {
  const element = el as HTMLElement;

  element.style.height = "0";
  element.style.overflow = "hidden";
};

const enter = (el: Element) => {
  const element = el as HTMLElement;

  nextTick(() => {
    element.style.transition = "height 0.5s ease-out";
    element.style.height = `${element.scrollHeight}px`;
  });
};

const afterEnter = (el: Element) => {
  const element = el as HTMLElement;

  // remove inline height for responsive behavior
  element.style.height = "auto";
  element.style.overflow = "";
};

const beforeLeave = (el: Element) => {
  const element = el as HTMLElement;

  // set to fixed ensuring transition
  element.style.height = `${element.scrollHeight}px`;
};

const leave = (el: Element) => {
  const element = el as HTMLElement;

  nextTick(() => {
    element.style.transition = "height 0.5s ease-out";
    element.style.height = "0";
  });
};
</script>

<style scoped>
.slide-container {
  overflow: hidden;
}
</style>
